export default "__VITE_ASSET__2f1fd23a__"